const isDevelopment = process.env.NODE_ENV === 'development';
const configuredApiBaseUrl = process.env.VUE_APP_API_BASE_URL || '';

function getDefaultApiBaseUrl() {
  if (isDevelopment) {
    const { hostname = '', port = '' } = typeof window !== 'undefined' ? window.location : {};

    if (hostname.toLowerCase() === 'localhost' && port === '8080') {
      return 'http://localhost:8000';
    }

    return '';
  }

  const hostname = typeof window !== 'undefined'
    ? window.location.hostname.toLowerCase()
    : '';

  if (hostname === 'test.fc.umbgrup.ro') {
    return 'https://test.uti.umbgrup.ro';
  }

  if (hostname === 'fc.umbgrup.ro') {
    return 'https://uti.umbgrup.ro';
  }

  return 'https://uti.umbgrup.ro';
}

export const API_BASE_URL = configuredApiBaseUrl || getDefaultApiBaseUrl();

export const IMAGE_BASE_URL = API_BASE_URL
  ? `${API_BASE_URL.replace(/\/$/, '')}/images/`
  : '/images/';
